import List from '@mui/material/List';
import { DemoItem } from '../DemoItem';
import {
  Typography,
} from '@mui/material';

const DemosList = ({demos}:{demos:any[]}) => {
  return demos.length > 0 ? (
    <List disablePadding sx={{ 
      display: 'flex', 
      flexDirection: 'row', 
      justifyContent:'space-between',
      flexWrap: 'wrap',
      alignItems: 'flex-start'
    }}>
      {demos.slice(0, 5).map((item, index) => (
        <DemoItem item={item} key={index} />
      ))}
    </List>
  ) : (
    <Typography
        fontSize={'13px'}
        variant={'body1'}
        color={'text.secondary'}
        sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}
    >
        No Demos found
    </Typography>
  );;
};

export { DemosList };
